import { complaintEffectiveStatusKey } from './complaintStatus';

/** Employees may rate when complaint is resolved or archived. */
export function complaintStatusAllowsEmployeeRating(raw) {
  const s = complaintEffectiveStatusKey(raw);
  return s === 'resolved' || s === 'archived';
}

/**
 * Rating from complaint list/detail API (`rating_details`, legacy shapes, or top-level fields).
 * @returns {{ rating: number | null, feedback: string, accountName?: string, createdAt?: string } | null}
 */
export function complaintRatingFromRaw(raw) {
  if (!raw || typeof raw !== 'object') return null;

  const block =
    raw.rating_details ??
    raw.complaint_rating ??
    (Array.isArray(raw.complaint_ratings) && raw.complaint_ratings.length > 0
      ? raw.complaint_ratings[raw.complaint_ratings.length - 1]
      : null);

  const ratingRaw = block?.rating ?? raw.rating ?? raw.complaint_rating_value;
  const feedbackRaw = block?.feedback ?? raw.feedback ?? raw.rating_feedback ?? '';
  const accountName = block?.account_name ?? raw.rating_account_name ?? '';
  const createdAt = block?.created_at ?? raw.rating_created_at ?? '';

  const num = Number(ratingRaw);
  const hasRating = Number.isFinite(num) && num >= 1 && num <= 5;
  const feedback = feedbackRaw != null ? String(feedbackRaw).trim() : '';

  if (!hasRating && !feedback) return null;
  return {
    rating: hasRating ? Math.round(num) : null,
    feedback,
    ...(String(accountName).trim() ? { accountName: String(accountName).trim() } : {}),
    ...(String(createdAt).trim() ? { createdAt: String(createdAt).trim() } : {}),
  };
}

export function hasComplaintRating(raw) {
  const r = complaintRatingFromRaw(raw);
  return r != null && r.rating != null && r.rating >= 1;
}
